/**
 * LEGO SPIKE PRIME TOOLBOX DEFINITION
 * Cấu hình danh mục Tiếng Việt 100% đầy đủ cho thanh công cụ Blockly với Shadow Blocks chuẩn mực.
 */
export const spikeToolbox = {
  kind: 'categoryToolbox',
  contents: [
    {
      kind: 'category',
      name: 'SỰ KIỆN',
      categorystyle: 'event_category',
      contents: [
        { kind: 'block', type: 'when_program_starts' },
        {
          kind: 'block',
          type: 'when_color_detected',
          inputs: {
            COLOR: {
              shadow: {
                type: 'reto_color_picker',
                fields: { COLOR: 'RED' }
              }
            }
          }
        },
        { kind: 'block', type: 'when_button_event' },
        {
          kind: 'block',
          type: 'when_timer_greater',
          inputs: {
            VALUE: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 5 }
              }
            }
          }
        },
        { kind: 'block', type: 'when_condition_true' }
      ]
    },
    {
      kind: 'category',
      name: 'ĐIỀU KHIỂN',
      categorystyle: 'control_category',
      contents: [
        {
          kind: 'block',
          type: 'wait_seconds',
          inputs: {
            SECONDS: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 1 }
              }
            }
          }
        },
        {
          kind: 'block',
          type: 'repeat_times',
          inputs: {
            TIMES: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 10 }
              }
            }
          }
        },
        { kind: 'block', type: 'forever_loop' },
        { kind: 'block', type: 'if_then' },
        { kind: 'block', type: 'if_then_else' },
        { kind: 'block', type: 'wait_until' },
        { kind: 'block', type: 'repeat_until' },
        { kind: 'block', type: 'loop_continue' },
        { kind: 'block', type: 'loop_break' }
      ]
    },
    {
      kind: 'category',
      name: 'CHUYỂN ĐỘNG',
      categorystyle: 'movement_category',
      contents: [
        {
          kind: 'block',
          type: 'reto_move_direction_speed',
          fields: { DIRECTION: 'FORWARD' },
          inputs: {
            SPEED: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 60 }
              }
            }
          }
        },
        { kind: 'block', type: 'reto_move_stop' },
        {
          kind: 'block',
          type: 'reto_motor_single',
          fields: { MOTOR: 'LEFT', DIRECTION: 'FORWARD' },
          inputs: {
            SPEED: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 50 }
              }
            }
          }
        },
        {
          kind: 'block',
          type: 'reto_set_servo_angle',
          inputs: {
            ANGLE: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 90 }
              }
            }
          }
        }
      ]
    },
    {
      kind: 'category',
      name: 'CẢM BIẾN',
      categorystyle: 'sensor_category',
      contents: [
        {
          kind: 'block',
          type: 'reto_distance_less_than',
          inputs: {
            DISTANCE: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 15 }
              }
            }
          }
        },
        { kind: 'block', type: 'reto_get_distance' },
        { kind: 'block', type: 'reto_line_detected' },
        {
          kind: 'block',
          type: 'reto_color_is',
          inputs: {
            COLOR: {
              shadow: {
                type: 'reto_color_picker',
                fields: { COLOR: 'RED' }
              }
            }
          }
        },
        { kind: 'block', type: 'reto_detected_color_id' },
        {
          kind: 'block',
          type: 'reto_button_pressed',
          fields: { BUTTON: '1' }
        },
        { kind: 'block', type: 'reto_get_light' },
        { kind: 'block', type: 'reto_timer' },
        { kind: 'block', type: 'reto_reset_timer' }
      ]
    },
    {
      kind: 'category',
      name: 'ĐÈN & CÒI',
      categorystyle: 'feedback_category',
      contents: [
        {
          kind: 'block',
          type: 'reto_set_rgb',
          inputs: {
            COLOR: {
              shadow: {
                type: 'reto_color_picker',
                fields: { COLOR: 'RED' }
              }
            }
          }
        },
        {
          kind: 'block',
          type: 'retocar_set_rgb_percent',
          inputs: {
            RED: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 100 }
              }
            },
            GREEN: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 0 }
              }
            },
            BLUE: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 0 }
              }
            }
          }
        },
        { kind: 'block', type: 'reto_rgb_off' },
        { kind: 'block', type: 'reto_set_indicator' },
        {
          kind: 'block',
          type: 'reto_buzzer_tone',
          inputs: {
            FREQ: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 1000 }
              }
            }
          }
        },
        { kind: 'block', type: 'reto_buzzer_off' }
      ]
    },
    {
      kind: 'category',
      name: 'PHÉP TOÁN',
      categorystyle: 'operator_category',
      contents: [
        {
          kind: 'block',
          type: 'operator_arithmetic',
          inputs: {
            A: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 1 }
              }
            },
            B: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 1 }
              }
            }
          }
        },
        {
          kind: 'block',
          type: 'operator_compare',
          inputs: {
            A: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 50 }
              }
            },
            B: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 50 }
              }
            }
          }
        },
        { kind: 'block', type: 'operator_logic' },
        { kind: 'block', type: 'operator_not' },
        {
          kind: 'block',
          type: 'operator_random',
          inputs: {
            FROM: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 1 }
              }
            },
            TO: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 10 }
              }
            }
          }
        },
        {
          kind: 'block',
          type: 'operator_between',
          inputs: {
            VAL: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 5 }
              }
            },
            MIN: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 1 }
              }
            },
            MAX: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 10 }
              }
            }
          }
        },
        {
          kind: 'block',
          type: 'operator_mod',
          inputs: {
            A: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 10 }
              }
            },
            B: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 3 }
              }
            }
          }
        },
        {
          kind: 'block',
          type: 'operator_round',
          inputs: {
            NUM: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 3.5 }
              }
            }
          }
        },
        {
          kind: 'block',
          type: 'operator_math_op',
          inputs: {
            NUM: {
              shadow: {
                type: 'math_number',
                fields: { NUM: 9 }
              }
            }
          }
        }
      ]
    },
    {
      kind: 'category',
      name: 'BIẾN SỐ',
      categorystyle: 'variable_category',
      custom: 'VARIABLE_CATEGORY'
    },
    {
      kind: 'category',
      name: 'DANH SÁCH',
      categorystyle: 'list_category',
      custom: 'LIST_CATEGORY'
    },
    {
      kind: 'category',
      name: 'KHỐI CỦA TÔI',
      categorystyle: 'procedure_category',
      custom: 'CUSTOM_PROCEDURE'
    }
  ]
};
